export default function validationMdpOublie(response) {
  const messages = [];
  if (!response.data.error || !response.data.error.details) {
    return messages;
  }
  const message = response.data.error.details;
  if (message.indexOf('NO_EMAIL_REGISTERED') !== -1) {
    messages.push({ message: 'connexion.popupMdpOublie.error.noEmailRegistered' });
  }
  if (message.indexOf('Utilisateur_NotFound') !== -1) {
    messages.push({ message: 'connexion.popupMdpOublie.error.userNotFound' });
  }
  if (message.indexOf('TENANT_INVALID') !== -1) {
    messages.push({ message: 'connexion.popupMdpOublie.error.tenantNotFound' });
  }
  if (message.indexOf('PasswordCode_Invalid') !== -1) {
    messages.push({ message: 'connexion.popupMdpOublie.error.invalidCode' });
  }
  if (message.indexOf('Password_Required') !== -1) {
    messages.push({ message: 'connexion.popupMdpOublie.error.passwordRequired' });
  }
  if (message.indexOf('PASSWORD|') !== -1) {
    messages.push({ message: 'connexion.resetPassword.error.password' });
  }
  if (message.indexOf('UTILISATEUR_PASSWORD_CONTAINS_FORBIDDEN_CHARACTERS') !== -1) {
    messages.push({
      message: 'validationUtilisateur.passwordNotValid',
    });
  }
  return messages;
}
